(function() { module.exports = window["Popper"]; }());